import style from "./treatingPhysicianModal.module.css";
import Input from "../input/Input";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import validateInput from "../../utilities/validations/validateInput";
import { language } from "../../stores/slices/languageSlice";
import {
  addressTypes,
  treatingPhysicianModalDetails,
  isModalFormOpen,
  addressTypesSelectIndex,
} from "../../stores/slices/appIntake/searchProviderSlice";
import { toast } from "react-toastify";

const TreatingPhysicianModal = (props) => {
  const selectedLanguage = useSelector(language).Appintake.medical;
  const dispatch = useDispatch();
  // const selectedLanguage = useSelector(language).Appintake.personalInformation;
  const getProviderDetails = useSelector((state) => state.searchProviderSlice);
  const patientInformation = useSelector(
        (state) => state.patientSearchSlice.patientInformation
      );
  const elementAddressType =
    getProviderDetails?.searchProviderData?.addressTypes;
  const ProviderAddresses =
    getProviderDetails?.searchProviderData?.ProviderAddresses;
  const errorMessage = useSelector(language).errorMessage;
  const [addressDetails, setAddressDetails] = useState({
    addressTypevalue: "",
    isAddressTypeValueValid: true,
    addressType: "",
    Address_Line1: {
      value: "",
      isValid: true,
    },
    Address_Line2: {
      value: "",
      isValid: true,
    },
    City: {
      value: "",
      isValid: true,
    },
    State: {
      value: "",
      isValid: true,
    },
    Zip_Code: {
      value: "",
      isValid: true,
    },
    Phone_Number: {
      value: "",
      isValid: true,
      errorMsg: false,
    },
    fax: {
      value: "",
      isValid: true,
      errorMsg: false,
    },
    Email_Address: {
      value: "",
      isValid: true,
    },
    extension: {
      value: "",
      isValid: true,
    },
    pySelected: false,
  });

  const inputOnChange = (e, validateName) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = validateInput(inputValue, validateName);
    if (name == "address_Type") {
      dispatch(addressTypesSelectIndex(inputValue));
      setAddressDetails((preinfo) => ({
        ...preinfo,
        addressTypevalue: inputValue,
        isAddressTypeValueValid: true,
        addressType: ProviderAddresses[inputValue].Type,

        Address_Line1: {
          value: ProviderAddresses[inputValue]?.AddressLine1,
          isValid: true,
        },
        Address_Line2: {
          value: ProviderAddresses[inputValue]?.AddressLine2,
          isValid: true,
        },
        City: {
          value: ProviderAddresses[inputValue]?.City,
          isValid: true,
        },
        State: {
          value: ProviderAddresses[inputValue]?.State,
          isValid: true,
        },
        Zip_Code: {
          value: ProviderAddresses[inputValue]?.ZipCode,
          isValid: true,
        },
        Phone_Number: {
          value: ProviderAddresses[inputValue]?.PhoneNumber
            ? ProviderAddresses[inputValue].PhoneNumber
            : "",
          isValid: true,
          errorMsg: false,
        },
        fax: {
          value: ProviderAddresses[inputValue]?.Fax
            ? ProviderAddresses[inputValue].Fax
            : "",
          isValid: true,
          errorMsg: false,
        },
        Email_Address: {
          value: ProviderAddresses[inputValue]?.Email
            ? ProviderAddresses[inputValue].Email
            : "",
          isValid: true,
        },
        extension: {
          value: ProviderAddresses[inputValue]?.Extension
            ? ProviderAddresses[inputValue].Extension
            : "",
          isValid: true,
        },
        pySelected: ProviderAddresses[inputValue].pySelected,
      }));
    }
    if (name == "Phone_Number" || name == "fax") {
      setAddressDetails((preinfo) => ({
        ...preinfo,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
          errorMsg:inputValidate.errorMsg
        },
      }));
    } else {
      setAddressDetails((preinfo) => ({
        ...preinfo,
        [name]: {
          value: inputValidate.value,
          isValid: inputValidate.isValid,
        },
      }));
    }
  };
  const CancelFunction = () => {
    dispatch(isModalFormOpen(false));
    props.setIsPopupOpen(false);
    setAddressDetails((preState) => ({
      ...preState,
      addressTypevalue: "",
      isAddressTypeValueValid: true,
      address_Type: {
        value: "",
        isValid: true,
      },
      Address_Line1: {
        value: "",
        isValid: true,
      },
      Address_Line2: {
        value: "",
        isValid: true,
      },
      City: {
        value: "",
        isValid: true,
      },
      State: {
        value: "",
        isValid: true,
      },
      Zip_Code: {
        value: "",
        isValid: true,
      },
      Phone_Number: {
        value: "",
        isValid: true,
        errorMsg: false,
      },
      fax: {
        value: "",
        isValid: true,
        errorMsg: false,
      },
      Email_Address: {
        value: "",
        isValid: true,
      },
      extension: {
        value: "",
        isValid: true,
      },
    }));
    dispatch(addressTypes([{ key: "", value: "" }]));
  };
  const submitFunction = () => {
    let isAddresTypeValidate =
      addressDetails.addressTypevalue != "" &&
      addressDetails.isAddressTypeValueValid;
    if (isAddresTypeValidate) {
      let isformvalidate =
        addressDetails.Phone_Number.value &&
        addressDetails.Phone_Number.isValid &&
        addressDetails.fax.value &&
        addressDetails.fax.isValid;
      if (isformvalidate) {
        const treatingPhysicianModalData = {
          firstName: props.searchProvider.modalFirstName,
          lastName: props.searchProvider.modalLastName,
          address_Type: addressDetails.addressType,
          Address_Line1: addressDetails.Address_Line1.value,
          Address_Line2: addressDetails.Address_Line2.value,
          City: addressDetails.City.value,
          State: addressDetails.State.value,
          Zip_Code: addressDetails.Zip_Code.value,
          Phone_Number: addressDetails.Phone_Number.value,
          fax: addressDetails.fax.value,
          Email_Address: addressDetails.Email_Address.value,
          extension: addressDetails.extension.value,
          isModalFormOpen: true,
          pySelected: addressDetails.pySelected,
        };
        dispatch(treatingPhysicianModalDetails(treatingPhysicianModalData));
        dispatch(isModalFormOpen(true));
        props.setIsPopupOpen(false);
      } else {
        setAddressDetails((preState) => ({
          ...preState,
          Phone_Number: {
            value: addressDetails.Phone_Number.value,
            isValid:
              addressDetails.Phone_Number.value != "" &&
              addressDetails.Phone_Number.isValid
                ? true
                : false,
          },
          fax: {
            value: addressDetails.fax.value,
            isValid:
              addressDetails.fax.value != "" && addressDetails.fax.isValid
                ? true
                : false,
          },
        }));
        toast.error(errorMessage?.mandatoryFieldsToastErrorMessage);
      }
    } else {
      setAddressDetails((preState) => ({
        ...preState,
        addressTypevalue: addressDetails.addressTypevalue,
        isAddressTypeValueValid:
          addressDetails.addressTypevalue != "" &&
          addressDetails.isAddressTypeValueValid
            ? true
            : false,
      }));
    }
  };

  return (
    <>
      <div className="modal_style">
        <div className="text-center px-8 pb-3">
          <p className="fs-xl">{patientInformation.Program == "CPR" ? "Application Intake - Treating Provider" : "Application Intake - Treating Provider"}</p>
        </div>
        <div className="px-8 pt-3">
          <p>
            {" "}
            <b>
              {props.searchProvider.modalFirstName}{" "}
              {props.searchProvider.modalLastName}
            </b>{" "}
            - {props.searchProvider.NationalProviderIdentifier}
          </p>
          <p>
            Other names:{" "}
            {props.searchProvider.AdditionalNames
              ? props.searchProvider.AdditionalNames.map((name) => (
                  <span
                    // className="ml-1 px-10"
                    key={name.Code}
                  >
                    {name.FirstName} {name.LastName}
                  </span>
                ))
              : ""}
          </p>
        </div>
        <div className="container d-flex justify-content-center pt-4 ">
          <div className={`${style.input_fields}`}>
            <Input
              type="selectIndex"
              id="address_Type"
              name="address_Type"
              label={"Address Type"}
              value={addressDetails.addressTypevalue}
              onChange={(e) => inputOnChange(e, "address")}
              isValid={addressDetails.isAddressTypeValueValid}
              elmentconfig={elementAddressType}
              errorMsg={errorMessage?.inputErrorMessage}
            />
          </div>
        </div>
        {addressDetails.addressTypevalue != "" &&
        addressDetails.isAddressTypeValueValid ? (
          <div class="grid input-fields columns-12 gap-4 gap-y-5 p-8 mb-5 container ">
            <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3">
              <i data-feather="phone"></i>
              <p className="p-1 ps-3 text-theme-1"> ADDRESS DETAILS</p>
            </div>
            <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6 ms-8">
              <b>Address Line 1</b>
              <br></br>
              <p>{addressDetails.Address_Line1.value}</p>
            </div>
            <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6 ms-8">
              <b>Address Line 2</b>
              <br></br>
              <p>
                {addressDetails.Address_Line2.value != ""
                  ? addressDetails.Address_Line2.value
                  : "--"}
              </p>
            </div>
            <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6 ms-8">
              <b>City</b>
              <br></br>
              <p>{addressDetails.City.value}</p>
            </div>
            <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6 ms-8">
              <b>State</b>
              <br></br>
              <p>{addressDetails.State.value}</p>
            </div>
            <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6 ms-8">
              <b>Zip Code</b>
              <br></br>
              <p>{addressDetails.Zip_Code.value}</p>
            </div>
            <div className="intro-y g-col-12 g-col-sm-12 fw-medium fs-base d-flex align-items-right border-bottom border-gray-200 dark-border-dark-5 mb-3 pt-3">
              <i data-feather="phone"></i>
              <p className="p-1 ps-3 text-theme-1">
                {" "}
                {selectedLanguage?.heading}
              </p>
            </div>
            <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6">
              <Input
                type="text"
                id="Phone_Number"
                label={"Phone Number"}
                name="Phone_Number"
                value={addressDetails.Phone_Number.value}
                isValid={addressDetails.Phone_Number.isValid}
                onChange={(e) => inputOnChange(e, "phoneNumber")}
                maxLength="12"
                errorMsg={
                  addressDetails.Phone_Number.errorMsg
                    ? "Phone/Fax number cannot begin with the number one"
                    : errorMessage?.inputErrorMessage
                }
              />
            </div>
            <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6">
              <Input
                type="email"
                id="Email_Address"
                label={"Email Address"}
                name="Email_Address"
                value={addressDetails.Email_Address.value}
                onChange={(e) => inputOnChange(e, "email")}
                isValid={addressDetails.Email_Address.isValid}
                errorMsg={errorMessage?.inputErrorMessage}
              />
            </div>
            <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6">
              <Input
                type="text"
                id="fax"
                label={"FAX"}
                name="fax"
                value={addressDetails.fax.value}
                onChange={(e) => inputOnChange(e, "phoneNumber")}
                isValid={addressDetails.fax.isValid}
                maxLength="12"
                errorMsg={
                  addressDetails.fax.errorMsg
                    ? "Phone/Fax number cannot begin with the number one"
                    : errorMessage?.inputErrorMessage
                }
              />
            </div>
            <div className="intro-y g-col-12 g-col-md-6 g-col-xl-6">
              <Input
                type="text"
                id="extension"
                label={"Extension"}
                name="extension"
                value={addressDetails.extension.value}
                onChange={(e) => inputOnChange(e, "ext")}
                isValid={addressDetails.extension.isValid}
                errorMsg={errorMessage?.inputErrorMessage}
                maxLength="10"
              />
            </div>
          </div>
        ) : null}

        <div className="d-flex  justify-content-end pt-5">
          <button onClick={CancelFunction} className={`btn ${style.buttons}`}>
            Cancel
          </button>

          <button
            onClick={submitFunction}
            className={`btn me-10 ${style.buttons1}`}
          >
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default TreatingPhysicianModal;
